// logger.js - Development-only logging utility
// Prevents console statements from appearing in production builds

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  // Log general information (only in development)
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  // Log warnings (only in development)
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  // Log errors (always logged, even in production)
  error: (...args) => {
    console.error(...args);
  },

  // Log informational messages (only in development)
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  // Log debug messages (only in development)
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
};
